module.exports = __webpack_public_path__ + "static/media/default-card.4cb27c2b.svg";